import type { ProjectConfig } from "@/types/project-config";

export const PROJECT_CONFIG: ProjectConfig = {
  name: "remora.sh",
  shortDescription:
    "Find high quality candidates from Hacker News for your startup.",
  longDescription:
    "Find high quality candidates from Hacker News for your startup.",
  domain: "hn-hiring.example.com",
  subreddit: "https://news.ycombinator.com",
};
